import React, { useState } from 'react';
import styles from './reviewpopup.module.css';
import { Star, UnFilledStars } from '../../../Svg';
import api from '../../../helper/Api';
import Toastify from '../../../helper/Toastify';

const ReviewPopup = ({ message, onClose, selectedProduct, id }) => {

  const [ratings, setRatings] = useState(1)
  const [review, setReview] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    const datas = {
      ratings,
      review,
      orderId: id,
      productId: selectedProduct?.productId?._id
    }
    // console.log(datas);
    if(!review){
      return Toastify.error('review field is required')
    }
    try {
      setLoading(true)
      const { data, status } = await api.writeReview(datas)
      if (status == 200) {
        onClose()
        // Toastify.success('order reviewed successfully')
      }
    } catch (err) {
      console.log(err);
      Toastify.error(err.response.data.message || 'something went wrong')
    }finally{
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setRatings(1)
    setReview('')
  }



  return (
    <div className={styles.blur_background}>
      <div className={styles.popup_card}>
        <div className={styles.popup_head}>
          <div>
            <span>
              Write a review
            </span>
          </div>
          <div>
            <button className={styles.close_btn} onClick={onClose}>
              &times;
            </button>
          </div>
        </div>
        <div>
          <p style={{ color: '#7E7E7E' }}>Add your rating and reviews here</p>
        </div>
        <div className={styles.reviewprod}>
          <div>
            <img src={selectedProduct?.productId?.featurerdImage} style={{ width: 60, height: 60 }} />
          </div>
          <div>
            {selectedProduct?.productId?.productName}
          </div>
        </div>
        <div className={styles.reviewicon}>
          <div>
            Rate this Product
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: 15 }}>
              {Array.from({ length: ratings }, (_, index) => (
                <span onClick={() => setRatings(index + 1)} >
                  <Star
                    key={index}
                    color="gold"
                    size={24}

                  />
                </span>

              ))}

              {Array.from({ length: 5 - ratings }, (_, index) => (
                <span onClick={() => setRatings(ratings + index + 1)} >
                  <UnFilledStars
                    key={ratings + index}
                    color="gray"
                    size={24}

                  />
                </span>
              ))}
            </div>


          </div>
        </div>
        <div className={styles.reviewSection}>
          <label htmlFor="review">Write Your Review</label>
          <textarea
            id="review"
            className={styles.reviewtextarea}
            placeholder="Your review here..."
            onChange={(e) => setReview(e.target.value)}
            value={review}
          />
        </div>
        <div className={styles.orderbuttons}>
          <button className={styles.trackOrderBtn} onClick={handleCancel}>Cancel</button>
          <button className={styles.invoiceBtn} onClick={handleSubmit} disabled={loading}>{loading ? "please wait...":"Submit"}</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewPopup;
